export default __webpack_public_path__ + "static/media/JCB.605afab1.svg";